/**
 *
 * CustomizeAcapellaStackModal
 *
 */
// @ts-nocheck
import * as React from 'react';
import {useState} from 'react';
import styled from 'styled-components/macro';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/pro-light-svg-icons";
import {useDispatch, useSelector} from "react-redux";
import {selectIsLoading, selectSelectedPreviewVoice, selectVoices} from "app/pages/VoiceModelsPage/slice/selectors";
import {Api} from "store/api";
import toast from "react-hot-toast";
import {AcapellaStackProductCard} from "app/components/AcapellaStackProductCard";
import {useVoiceModelsSlice} from "app/pages/VoiceModelsPage/slice";
import Waveform from "app/components/Waveform";
import {useNavigate, useOutletContext} from "react-router-dom";
import {VoiceSelectInput} from "app/components/voiceSelectInput";
import Drawer from "@mui/material/Drawer";
import {SongTermsSelect} from "app/components/SongTermsSelect";
import {
    OldPrice,
    Price, PriceAndDiscountContainer,
    PriceContainer,
    PriceDiscount
} from "app/components/GlobalAudioPlayer/priceAndDiscountContainer";
import {VoiceSelectButtonModal} from "app/components/voiceSelectButtonModal";

interface Props {
  open: boolean,
  onClose: () => void,
  title: string | JSX.Element | undefined,
  acapellaStack: any,
}

const style = {
  // position: 'absolute' as 'absolute',
  // top: '50%',
  // left: '50%',
  // transform: 'translate(-50%, -50%)',
  // width: 'calc(min(80vw, 1000px))',
  background: '#180D23',
  // border: '1px solid #FF74E9',
  // borderRadius: '20px',
  boxShadow: 24,
  textAlign: 'left',
  height: '100vh',
  overflowY: 'scroll',
};


export function getTypeOfControllaPrice(controlla_price, isCommercial) {
    for (let cprice of controlla_price) {
        if (cprice.slug.includes('-commercial')) {
            if (isCommercial) return cprice
        }
        else {
            if (!isCommercial) return cprice
        }
    }

    return 'N/A'
}

// TODO make redux controlled so we can use this modal in any context/page
export function CustomizeAcapellaStackModal(props: Props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userProfile] = useOutletContext();
    const { actions } = useVoiceModelsSlice();
    const voices = useSelector(selectVoices);
    const selectedPreviewVoice = useSelector(selectSelectedPreviewVoice);
    const isVoicesLoading = useSelector(selectIsLoading);
    const [isSelectingMultipleVoices, setIsSelectingMultipleVoices] = useState<boolean>(false);
    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const [error, setError] = useState(null);


    const { acapellaStack } = props
    const { acapella_stack_audio_files: AcapellaStackAudioFiles, controlla_price, acapella_stack_jobs } = acapellaStack
    const AcapellaStackAudioFilesStemPreviews = acapella_stack_jobs.filter(a => a?.input?.type === 'vocal-stem-preview')
    const [layers, setLayers] = useState(AcapellaStackAudioFilesStemPreviews.map(job => {
        return {
            acapella_stack_preview_audio_file_uuid: job.input?.uuid,
            audioFileUrl: job.input?.audio_file.storagePublicUrl,
            voiceModel: selectedPreviewVoice,
            voice_model_id: selectedPreviewVoice?.id,
            transpose: 0,
        }
    }));

    // If false, personal use terms. True, commercial use.
    const [isCommercial, setIsCommercial] = useState(false)

    const personalControllaPrice = getTypeOfControllaPrice(controlla_price, false)
    const personalPrice = personalControllaPrice.price

    const commercialControllaPrice = getTypeOfControllaPrice(controlla_price, true)
    const commercialPrice = commercialControllaPrice.price

    const price = isCommercial ? commercialPrice : personalPrice

    const priceAsCredits = price * 100
    const creditBalance = userProfile?.marketplace_credits
    let showPriceAsCredits = priceAsCredits <= creditBalance
    if (isCommercial) showPriceAsCredits = false
    const handleChangeTerms = (isCommercialSelected) => {
        setIsCommercial(isCommercialSelected)
    }

    // // fetch voice models
    // useEffect(() => {
    //     dispatch(actions.fetchVoices());
    // }, []);

    // Send layers to create customized UserAcapellaStack
    const handleSubmit = async () => {
        setIsCheckingOut(true);
        const acapella_stack_uuid = acapellaStack.uuid
        const price_slug = isCommercial ? commercialControllaPrice.slug : personalControllaPrice.slug
        const layersRequest = layers.map(l => {
            return {
                acapella_stack_preview_audio_file_uuid: l.acapella_stack_preview_audio_file_uuid,
                voice_model_id: l.voice_model_id,
                transpose: l.transpose,
            }
        })

        // Create UserAcapellaStack
        try {
            const response = await Api.createUserAcapellaStack(price_slug, layersRequest)
            console.log(response)
            const { user_acapella_stack } = response
            const user_acapella_stack_uuid = user_acapella_stack.uuid
            // Checkout with stripe price
            const metadata = { user_acapella_stack_uuid }
            await Api.redirectToCheckoutSlugWithMetadata(price_slug, metadata)
        } catch (e) {
            toast.error(e);
            setError(e);
        }

        setIsCheckingOut(false);
    }

    const handleSubmitWithCredits = async () => {
        setIsCheckingOut(true);
        const acapella_stack_uuid = acapellaStack.uuid
        const price_slug = isCommercial ? commercialControllaPrice.slug : personalControllaPrice.slug
        const layersRequest = layers.map(l => {
            return {
                acapella_stack_preview_audio_file_uuid: l.acapella_stack_preview_audio_file_uuid,
                voice_model_id: l.voice_model_id,
                transpose: l.transpose,
            }
        })

        // TODO create user acapella stack draft
        // Create UserAcapellaStack
        let user_acapella_stack_uuid = null
        try {
            const response = await Api.createUserAcapellaStack(price_slug, layersRequest)
            console.log(response)
            const { user_acapella_stack } = response
            user_acapella_stack_uuid = user_acapella_stack.uuid
            // Checkout with stripe price
            const purchaseResponse = await Api.purchaseUserAcapellaStack(user_acapella_stack_uuid)
            navigate('/app/library')
        } catch (e) {
            toast.error('Failed to get acapella');
            setError('Failed to get acapella');
        }

        setIsCheckingOut(false);
    }

    const getVoiceFromId = (id) => {
        for (let voice of voices) {
            if (voice.id === id) {
                return voice;
            }
        }
        return undefined;
    }

    const clickSelectMultipleVoices = () => {
        const newLayers = AcapellaStackAudioFilesStemPreviews.map(job => {
            return {
                acapella_stack_preview_audio_file_uuid: job.input?.uuid,
                audioFileUrl: job.input?.audio_file.storagePublicUrl,
                voiceModel: layers[0].voiceModel,
                voice_model_id: layers[0].voiceModel?.id,
                transpose: layers[0].transpose,
            }
        })

        setLayers(newLayers);
        setIsSelectingMultipleVoices(true)
    }
    const clickSelectOneVoice = () => {
        const singleVoiceLayers = AcapellaStackAudioFilesStemPreviews.map(job => {
            return {
                acapella_stack_preview_audio_file_uuid: job.input?.uuid,
                audioFileUrl: job.input?.audio_file.storagePublicUrl,
                voiceModel: layers[0].voiceModel,
                voice_model_id: layers[0].voiceModel?.id,
                transpose: layers[0].transpose,
            }
        })
        setLayers(singleVoiceLayers)
        setIsSelectingMultipleVoices(false)
    }

    const setLayerSelectedVoice= (layerIndex, voice) => {
        const newLayers = [...layers]
        newLayers[layerIndex].voiceModel = voice;
        newLayers[layerIndex].voice_model_id = voice.id;
        setLayers(newLayers);
    }

    const setAllLayerSelectedVoice = (voice) => {
        const newLayers = layers.map(l => {
            l.voiceModel = voice;
            l.voice_model_id = voice.id;
            return l;
        })
        setLayers(newLayers);
    }

    const isVoiceSelected = () => {
        let selectedVoiceLayers = layers.map(l => l.voiceModel).filter(vm => vm)

        if (selectedVoiceLayers.length == 0) {
            return false
        }
        return true
    }

    const setLayerTranspose= (layerIndex, transpose) => {
        const newLayers = [...layers]
        newLayers[layerIndex].transpose = transpose;
        setLayers(newLayers);
    }
    const setAllLayerTranspose = (transpose) => {
        const newLayers = layers.map(l => {
            l.transpose = transpose;
            return l
        });
        setLayers(newLayers);
    }

    console.log('layers', layers);

    let primaryActionEl = (
        <button className="primary-button small" onClick={handleSubmit} disabled={!isVoiceSelected()}>
            BUY IN MY VOICE
        </button>

    );
    if (showPriceAsCredits) {
        primaryActionEl = (
            <button className="primary-button small" onClick={handleSubmitWithCredits} disabled={!isVoiceSelected()}>
                GET IN MY VOICE
            </button>
        )
    }

    let checkingOutButtonState = (
        <button className="primary-button small" onClick={()=>{}} disabled={true}>
            Checking out...
        </button>
    )

    let priceAndDiscountEl = (
        <PriceAndDiscountContainer>
            <PriceContainer>
                <OldPrice>
                    {'$' + ((price * 2).toFixed(2) || '70.00')}
                </OldPrice>
                <Price>
                    {'$' + (price.toFixed(2) || '35.00')}
                </Price>
            </PriceContainer>
            <PriceDiscount>
                50% OFF!
            </PriceDiscount>
        </PriceAndDiscountContainer>
    )
    if (showPriceAsCredits) {
        priceAndDiscountEl = (
            <PriceAndDiscountContainer>
                <PriceContainer>
                    <OldPrice>
                        {priceAsCredits * 2}
                    </OldPrice>
                    <Price>
                        {priceAsCredits}
                    </Price>
                </PriceContainer>
                <PriceDiscount>
                    Balance: {creditBalance}
                </PriceDiscount>
            </PriceAndDiscountContainer>
        )
    }

  return (
      <>
          <Drawer
              anchor={'right'}
              open={props.open}
              onClose={props.onClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
                <ModalContent>
                  <ModalHeader>
                    <ModalTitle>
                          Create this full song in your voice
                    </ModalTitle>
                    <FontAwesomeIcon icon={faTimes} onClick={props.onClose} size={"xs"} />
                  </ModalHeader>

                  <SingleVoiceSelectionContainer>
                      {!isSelectingMultipleVoices && (
                          <>
                              <FormSectionTitle> Select a voice </FormSectionTitle>
                              <FormSectionSubtitle> Try using a -12 or +12 pitch shift if this song is out of your range </FormSectionSubtitle>
                              <SingleVoiceRow>
                                  <VoiceSelectButtonModal
                                      buttonStyles={{
                                          height: '40px'
                                      }}
                                      loading={isVoicesLoading}
                                      onChange={(o) => setAllLayerSelectedVoice(o)}
                                      value={layers.map((l) => l.voiceModel)[0]}
                                      optionLabel={(voice) => voice.name}
                                      optionValue={(voice) => voice.id}
                                      small={true}
                                  />
                                  <LayerTransposeContainer>
                                      <PitchShiftLabel>Pitch Shift</PitchShiftLabel>
                                      <input className="small" type="text" style={{width: "65px"}} value={layers[0].transpose}
                                             onChange={(e) => setAllLayerTranspose(e.target.value)}/>
                                  </LayerTransposeContainer>
                              </SingleVoiceRow>
                              <SwitchToMultipleVoicesCaption>
                                  Want to use multiple voices or pitch shifts?
                                  <SwitchToMultipleVoicesButton onClick={clickSelectMultipleVoices}>
                                      Customize each layer
                                  </SwitchToMultipleVoicesButton>
                              </SwitchToMultipleVoicesCaption>
                          </>
                      )}
                      {isSelectingMultipleVoices && (
                          <>
                              <FormSectionTitle> Select a voice/transpose for each layer </FormSectionTitle>
                              <MultipleVoiceSelectionContainer>
                                  {layers.map((layer, index) => {

                                      return (
                                          <CustomizeLayerRow key={index}>
                                              <LayerWaveformContainer>
                                                <LayerAudioLabel>{'Layer ' + index}</LayerAudioLabel>
                                                <Waveform small={true} uniqueKey={index + 'layerAudio'} url={layer.audioFileUrl} downloadButtonElement={<></>} />
                                              </LayerWaveformContainer>
                                              <LayerTransposeContainer>
                                                  {index === 0 && (<PitchShiftLabel>Pitch Shift</PitchShiftLabel>)}
                                                  <input className="small" type="text" style={{width: "60px"}} value={layer.transpose}
                                                         onChange={(e) => setLayerTranspose(index, e.target.value)}/>
                                              </LayerTransposeContainer>
                                              <VoiceSelectButtonModal
                                                  buttonStyles={{
                                                      height: '40px'
                                                  }}
                                                  loading={isVoicesLoading}
                                                  onChange={(o) => setLayerSelectedVoice(index, o)}
                                                  value={layer.voiceModel}
                                                  optionLabel={(voice) => voice.name}
                                                  optionValue={(voice) => voice.id}
                                                  small={true}
                                              />
                                              <SwitchToSingleVoiceButton onClick={clickSelectOneVoice}>
                                                  Use one voice/transpose for all layers
                                              </SwitchToSingleVoiceButton>
                                          </CustomizeLayerRow>
                                      );
                                  })}
                              </MultipleVoiceSelectionContainer>
                          </>
                      )}
                  </SingleVoiceSelectionContainer>

                  <FormSectionTitle> <br/> Choose your terms </FormSectionTitle>
                  <FormSectionSubtitle> You can upgrade your license at any time </FormSectionSubtitle>
                  <SongTermsSelect isCommercial={isCommercial} onChange={handleChangeTerms} personalPrice={personalPrice} commercialPrice={commercialPrice} showPriceAsCredits={showPriceAsCredits}/>

                    <br/>
                    <br/>
                </ModalContent>
                <ModalFooter>

                    <AgreeToTerms>
                        By generating this song in your voice, you agree to the terms of&nbsp;
                        {isCommercial ? (
                            <TermLink href={'https://controlla.notion.site/Commercial-License-Agreement-b5abcc9a828140d287de35beb0f61ab4?pvs=4'}>
                                Commercial Use
                            </TermLink>
                        ) : (
                            <TermLink href={'https://controlla.notion.site/Personal-Use-License-Covers-f4dd84d3c8724ae8b608920dfe9190f4?pvs=4'}>
                                Personal Use
                            </TermLink>
                        )}
                    </AgreeToTerms>

                    <PriceAndButton>
                        {priceAndDiscountEl}
                        {error && <p className="error">{error}</p>}
                        {!isCheckingOut && (
                            <>
                                {primaryActionEl}
                            </>
                        )}
                        {isCheckingOut && (
                            <>
                                {checkingOutButtonState}
                            </>
                        )}
                    </PriceAndButton>


                </ModalFooter>
            </Box>
          </Drawer>
      </>
  );
}
const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  padding-top: 32px;
  
`;

const ModalTitle = styled.div`
  color: #FFF;
  text-align: center;
  font-family: Raleway;
  font-size: 36px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  
  margin-bottom: 20px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  position: relative;
  padding-right: 32px;
  padding-left: 32px;
  padding-bottom: 32px;
  background: #180d23;
  max-width: 680px;

  @media only screen and (max-width: 600px) {
    max-width: 100vw;
  }

  min-height: 480px;
  
  .bg-video {
    position: absolute;
    width: 100%;
    top:-20%;
    left: 0;
    right: 0;
    z-index: -1;
  }
`;

const ModalFooter = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: 600px) {
    justify-content: stretch;
  }

  background: #210431;

  padding-right: 32px;
  padding-left: 32px;
`;
const PriceAndButton = styled.div`
  flex-shrink: 0;
  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const AcapellaPreviewContainer = styled.div`
  margin-left: 60px;
  margin-right: 60px;
`

const SingleVoiceSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  
  margin-top: -20px;
  
  max-width: 500px;
  
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

const FormSectionTitle = styled.div`
  color: #FFF;

  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 10px;
  margin-top: 40px;
`

const FormSectionSubtitle = styled.div`
  color: rgba(245, 225, 255, 0.74);

  text-overflow: ellipsis;
  font-family: Raleway;
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: normal;
  margin-bottom: 20px;
`;

const SingleVoiceRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  padding-top: 10px;
`;

const SwitchToMultipleVoicesCaption = styled.p`
  text-align: left;
  font-size: 16px;
  margin-left: 10px;
  padding-top: 10px;
`;
const SwitchToMultipleVoicesButton = styled.span`
  font-size: 16px;
  text-decoration: underline;
  color: #FF74E9;
  margin-left: 10px;
`;

const CustomizeLayerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: center;
  
  margin-top: 10px;
  
`;

const LayerWaveformContainer = styled.div`
  flex-grow: 2;
  max-width: 300px;

  position: relative;
`;

const LayerTransposeContainer = styled.div`
  flex-grow: 0;
  max-width: 100px;
  height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  
  input {
    margin: 0px !important;
    border-radius: 20px;
  }
`;

const PitchShiftLabel = styled.div`
  font-family: 'Raleway', sans-serif;
  line-height: 1em;
  font-size: 14px;
  
  position: absolute;
  top: -1.2em;
`;

const MultipleVoiceSelectionContainer = styled.div`
  margin-top: 40px;
  margin-right: 40px;
  margin-left: 40px;
  position: relative;
`;

const LayerAudioLabel = styled.div`
  font-family: 'Raleway', sans-serif;
  line-height: 1em;
  font-size: 18px;
  font-weight: 700;
  text-shadow: #000000 2px 2px 4px;

  position: absolute;
  top: calc(50% - 0.5em);
  z-index: 100;
  left: 40px;
`;

const SwitchToSingleVoiceButton = styled.div`
  font-family: 'Raleway', sans-serif;
  line-height: 1em;
  font-size: 16px;
  text-decoration: underline;
  color: #FF74E9;
  
  position: absolute;
  top: -1.2em;
  right: 0;
`;

const AgreeToTerms = styled.div`
  color: rgba(245, 225, 255, 0.74);

  font-family: Raleway;
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: normal;
  margin-top: 20px;
  
  flex-shrink: 1;
`;

const TermLink = styled.a`
  color: #FF74E9;
`;